import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {
    assetsDialogsSelector,
    loadings,
    setCreateSettingRowDialogAction,
    virtualAssetsSettingsSelector
} from "../../store/store";
import {useForm} from "../../../../../newShared/hooks/useForm";
import {
    PATH_LOCAL_ASSET_MANAGEMENT_VIRTUAL_ASSETS,
    PATH_LOCAL_ASSET_MANAGEMENT_VIRTUAL_ASSETS_ID,
    PATH_LOCAL_ASSET_MANAGEMENT_VIRTUAL_ASSETS_NEW
} from "../../constants";
import {useSetBreadcrumbs} from "../../../../barsEnvironment/breadcrumbs/hooks/useBreadcrumbs";
import {PATH_LOCAL_ASSET_MANAGEMENT} from "../../../../../newShared/constants";
import {createVirtualAssetAction, getVirtualAssetsSettingsAction,} from "../../store/actions";
import {TSetCreateSettingRowDialog, TVirtualAsset} from "../../types";


export const useVirtualAssetNew = () => {
    //root
    const dispatch = useDispatch();
    const history = useHistory();
    const {t: tMenu} = useMainTranslation('', {keyPrefix: 'LeftMenu'});

    //selectors
    const {isLoadingSettings, isLoadingCreateAsset} = useSelector(loadings);
    const settings = useSelector(virtualAssetsSettingsSelector);
    const {createAsset: {isOpen: isOpenCreateAsset}} = useSelector(assetsDialogsSelector);


    const initialVirtualAsset: TVirtualAsset = {
        id: '',
        name: '',
        type: '',
        virtualMachineName: '',
        virtualMachineIp: '',
        ip: '',
        owner: '',
        customFields: {},
    }
    //form
    const {form, setForm, handleChange} = useForm<TVirtualAsset>(initialVirtualAsset);

    const controller = new AbortController();
    useEffect(() => {
        if(!settings) {
            dispatch(getVirtualAssetsSettingsAction({data: {organizationId: '', workspaceId: ''}, signal: controller.signal}));
        }
        if(settings && settings.customFields && Object.keys(settings.customFields).length){
            const customFields: { [key: string]: string } = {};
            Object.keys(settings.customFields).length && Object.keys(settings.customFields).forEach((key) => customFields[key] = '');
            setForm({...form, customFields});
        }

        return () => {
            controller.abort();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(settings && settings.customFields && Object.keys(settings.customFields).length){
            const customFields: { [key: string]: string } = {};
            Object.keys(settings.customFields).forEach((key) => customFields[key] = '');
            setForm({...form, customFields});
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settings, settings?.customFields]);

    useEffect(() => {
        isOpenCreateAsset && setForm(initialVirtualAsset);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpenCreateAsset]);


    useSetBreadcrumbs([
        {
            title: tMenu('Asset Management'),
            path: PATH_LOCAL_ASSET_MANAGEMENT
        },
        {
            title: tMenu('Virtual assets'),
            path: PATH_LOCAL_ASSET_MANAGEMENT_VIRTUAL_ASSETS
        },
        {
            title: tMenu('New asset'),
            path: PATH_LOCAL_ASSET_MANAGEMENT_VIRTUAL_ASSETS_NEW
        },
    ]);

    //actions
    const handleGoBack = () => history.push(PATH_LOCAL_ASSET_MANAGEMENT_VIRTUAL_ASSETS);

    // const isOkId = () => {
    //     return form.id.trim().length > 0 ? Boolean( form.id.match(/^[A-Za-z0-9-_]+$/)) : true;
    // }

    const handleSave = () => {
        form.name.trim().length && dispatch(createVirtualAssetAction({data: {workspaceId: '', organizationId: '', asset: form}, onSuccess}));
    }

    const onSuccess = (id: string) => {
        history.push(PATH_LOCAL_ASSET_MANAGEMENT_VIRTUAL_ASSETS_ID.replace(':id', id));
    }


    const handleSetType = (title: string) => {
        setForm({...form, type: title});
    }

    const handleSetManager = (newValue: string) => {
        setForm({...form, owner: newValue ? newValue : ''});
    }

    const handleChangeCustomField = (event:React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        setForm((prevValues) => ({
            ...prevValues,
            customFields: {
                ...prevValues.customFields,
                [event.target.name]: event.target.value,
            },
        }));
    };

    //CreateAssetDialog
    const openCreateSettingRowDialog = (data: TSetCreateSettingRowDialog) => {dispatch(setCreateSettingRowDialogAction(data))};


    return {
        settings,
        form,
        handleChange,

        handleSave,
        handleGoBack,
        onSuccess,
        handleSetManager,
        handleChangeCustomField,
        handleSetType,

        isLoadingSettings,
        isLoadingCreateAsset,

        createAssetDialog: {
            isOpenCreateAsset,
        },

        openCreateSettingRowDialog,
    }
}
